module.exports = __webpack_public_path__ + "static/media/valor2.bad8bf02.png";